// extracted by mini-css-extract-plugin
export default {"accessRightIndicator":"institutionTeamCard_accessRightIndicator__lrNDg"};